import React from "react";
import { ProfileContainer } from "../styled_components/containers";
import useAvatar from "../../games/hooks/useAvatar";
import egg from "../assets/egg.png";

function Profile({ name }) {
  const avatar  = useAvatar();
  console.log(avatar.details);

  function AvatarImage(){
    let avatarURL;
    if (avatar.details == undefined || avatar.details == ""){
      avatarURL = egg;
    }else{
      avatarURL = avatar.details;
    }
    return avatarURL;
  }

  return (
    <ProfileContainer>
        <span>{name ? <div dangerouslySetInnerHTML ={{ __html:(name)}}/> : "Fetching"}</span>
      <img style={{display: "none"}} src={AvatarImage()} alt="tamogotchi" />
    </ProfileContainer>
  );
}

export default Profile;
